import { FunctionComponent, HTMLAttributes } from 'react';

const IconTruckFilled: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = ({
  title,
  ...props
}) => (
  <svg
    {...props}
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title && <title>{title}</title>}
    <path
      d="M3.88672 1V9.64616H4.97865C4.98557 9.37143 5.09948 9.11027 5.29614 8.91832C5.4928 8.72636 5.75667 8.6188 6.03148 8.61854C6.30636 8.6187 6.5703 8.72623 6.76704 8.91819C6.96379 9.11015 7.07776 9.37137 7.08468 9.64616H11.6862V1H3.88672Z"
      fill="#359AD2"
      stroke="#359AD2"
    />
    <path
      d="M4 5H1M4 3H1.9M4 7H1.9"
      stroke="#359AD2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.9 7C5.9 7.27614 5.67614 7.5 5.4 7.5L4 7.5C3.72386 7.5 3.5 7.27614 3.5 7C3.5 6.72386 3.72386 6.5 4 6.5L5.4 6.5C5.67614 6.5 5.9 6.72386 5.9 7ZM6.5 5C6.5 5.27614 6.27614 5.5 6 5.5L4 5.5C3.72386 5.5 3.5 5.27614 3.5 5C3.5 4.72386 3.72386 4.5 4 4.5L6 4.5C6.27614 4.5 6.5 4.72386 6.5 5ZM5.9 3C5.9 3.27614 5.67614 3.5 5.4 3.5L4 3.5C3.72386 3.5 3.5 3.27614 3.5 3C3.5 2.72386 3.72386 2.5 4 2.5L5.4 2.5C5.67614 2.5 5.9 2.72386 5.9 3Z"
      fill="white"
    />
    <path
      d="M7.08589 9.67271C7.08589 9.81114 7.05862 9.94822 7.00564 10.0761C6.95266 10.204 6.87502 10.3202 6.77713 10.4181C6.67924 10.516 6.56301 10.5937 6.43511 10.6466C6.30721 10.6996 6.17015 10.7269 6.03172 10.7269C5.89328 10.7269 5.75618 10.6996 5.62828 10.6466C5.50039 10.5937 5.38419 10.516 5.2863 10.4181C5.18841 10.3202 5.11077 10.204 5.05779 10.0761C5.00481 9.94822 4.97754 9.81114 4.97754 9.67271C4.97754 9.53427 5.00481 9.39719 5.05779 9.26929C5.11077 9.1414 5.18841 9.02518 5.2863 8.92729C5.38419 8.8294 5.50039 8.75176 5.62828 8.69878C5.75618 8.64581 5.89328 8.61853 6.03172 8.61853C6.17015 8.61853 6.30721 8.64581 6.43511 8.69878C6.56301 8.75176 6.67924 8.8294 6.77713 8.92729C6.87502 9.02518 6.95266 9.1414 7.00564 9.26929C7.05862 9.39719 7.08589 9.53427 7.08589 9.67271Z"
      stroke="#359AD2"
    />
    <path
      d="M12.3994 2.49475V9.68868H12.9984C12.9982 9.68334 12.998 9.67799 12.9979 9.67265C12.9979 9.39307 13.109 9.12494 13.3067 8.92725C13.5044 8.72956 13.7725 8.61849 14.0521 8.61849C14.3317 8.61849 14.5998 8.72956 14.7975 8.92725C14.9952 9.12494 15.1062 9.39307 15.1062 9.67265C15.106 9.67799 15.1057 9.68334 15.1054 9.68868H16.9998L16.9844 4.70232L14.7768 2.49475H12.3994Z"
      stroke="#359AD2"
    />
    <path
      d="M15.1064 9.67271C15.1064 9.81114 15.0791 9.94822 15.0261 10.0761C14.9732 10.204 14.8955 10.3202 14.7976 10.4181C14.6998 10.516 14.5835 10.5937 14.4556 10.6466C14.3277 10.6996 14.1907 10.7269 14.0522 10.7269C13.9138 10.7269 13.7767 10.6996 13.6488 10.6466C13.5209 10.5937 13.4047 10.516 13.3068 10.4181C13.2089 10.3202 13.1313 10.204 13.0783 10.0761C13.0253 9.94822 12.998 9.81114 12.998 9.67271C12.998 9.53427 13.0253 9.39719 13.0783 9.26929C13.1313 9.1414 13.2089 9.02518 13.3068 8.92729C13.4047 8.8294 13.5209 8.75176 13.6488 8.69878C13.7767 8.64581 13.9138 8.61853 14.0522 8.61853C14.1907 8.61853 14.3277 8.64581 14.4556 8.69878C14.5835 8.75176 14.6998 8.8294 14.7976 8.92729C14.8955 9.02518 14.9732 9.1414 15.0261 9.26929C15.0791 9.39719 15.1064 9.53427 15.1064 9.67271V9.67271Z"
      stroke="#359AD2"
    />
    <path d="M16.5021 8.1167H15.5098V8.77382H16.5021V8.1167Z" fill="#359AD2" />
  </svg>
);

export default IconTruckFilled;
